import api from './api';

export const leaveService = {
  getAll: async (empId = null) => {
    const url = empId ? `/leaves?emp_id=${empId}` : '/leaves';
    const response = await api.get(url);
    return response.data.leaves;
  },

  getById: async (id) => {
    const response = await api.get(`/leaves/${id}`);
    return response.data.leave;
  },

  create: async (leaveData) => {
    const response = await api.post('/leaves', leaveData);
    return response.data.leave;
  },

  update: async (id, leaveData) => {
    const response = await api.put(`/leaves/${id}`, leaveData);
    return response.data.leave;
  },

  delete: async (id) => {
    const response = await api.delete(`/leaves/${id}`);
    return response.data;
  },

  getLeaveCount: async (empId, projectCode, month) => {
    const response = await api.get(`/leaves/count?emp_id=${empId}&project_code=${projectCode}&month=${month}`);
    return response.data;
  },

  batchUpload: async (records) => {
    const response = await api.post('/leaves/batch', { records });
    return response.data;
  },
};
